// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"30d49e41","620":"346e2cbb","790":"63b55b4e","793":"a593b9a2","851":"2f425d2a","908":"f4aacb1c"}[chunkId] + ".chunk.js";
};